export const CRM_TABLE_COLUMN_DEFAULTS = {
  reference: true,
  name: true,
  phone: true,
  email: false,
  address: true,
  city: false,
  state: false,
  zip_code: false,
  country: false,
  tax_id: false,
  vat_number: false,
  currency: true,
  ltv: false,
  amount_paid: false,
  balance_due: true,
  overdue: true,
  created_at: true,
  created_by: true,
  action: true
}

export const CRM_TABLE_COLUMN_LABELS = {
  reference: 'reference',
  name: 'name',
  phone: 'phone',
  email: 'email',
  address: 'address',
  city: 'city',
  state: 'state',
  zip_code: 'zip_code',
  country: 'country',
  tax_id: 'tax_id',
  vat_number: 'vat_number',
  currency: 'currency',
  ltv: 'ltv',
  amount_paid: 'amount_paid',
  overdue: 'overdue',
  created_at: 'created_at',
  created_by: 'created_by',
  action: 'action'
}

export function getCrmTableColumnDefaults(entity = 'clients') {
  const columns = { ...CRM_TABLE_COLUMN_DEFAULTS }

  if (entity === 'suppliers') {
    delete columns.currency
  }

  return columns
}

